import LocalContactInfo from './components/LocalContactInfo.vue';
import InitLazyComponent from 'Modules/InitLazyComponent';

const elements = document.querySelectorAll('.local-contact-info-component');
const initLazyComponent = new InitLazyComponent({
  selectors: elements,
  components: { LocalContactInfo },
  template: '<LocalContactInfo />',
});

initLazyComponent.init();
